import { CM0013APIImpl } from './ServiceImpl';

const CM0013Service = (api: CM0013APIImpl) => {
    return {};
};

export default CM0013Service;
